import { useState, useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { cn } from "../../utils/cn";

const RenderImage = ({
  src,
  alt = "Image",
  className = "",
  imageClassName = "",
  fallbackSrc = null,
  placeholderImage = "",
  fallback = "Image unavailable",
  objectFit = "object-cover",
  rounded = "rounded-md",
  loading = false,
  onClick = null,
  effect = "blur",
  style = {},
  ...props
}) => {
  const getInitialSrc = () => src || fallbackSrc || placeholderImage;

  const [currentSrc, setCurrentSrc] = useState(getInitialSrc);
  const [hasError, setHasError] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);

  // Sync image when src / fallback changes (theme switch safe)
  useEffect(() => {
    setCurrentSrc(getInitialSrc());
    setHasError(false);
    setHasLoaded(false);
  }, [src, fallbackSrc, placeholderImage]);

  const handleError = () => {
    if (currentSrc === src && fallbackSrc) {
      setCurrentSrc(fallbackSrc);
    } else {
      setHasError(true);
    }
  };

  // Skeleton loading state
  if (loading) {
    return (
      <div
        className={cn(
          "w-full h-full bg-slate-300 animate-pulse",
          rounded,
          className
        )}
      />
    );
  }

  return (
    <div
      className={cn(
        "w-full h-full flex items-center justify-center overflow-hidden",
        rounded,
        className
      )}
      style={style}
      onClick={onClick}
    >
      {!hasError && currentSrc ? (
        <LazyLoadImage
          key={currentSrc} // ensures proper reload
          src={currentSrc}
          alt={alt}
          effect={effect}
          onError={handleError}
          onLoad={() => setHasLoaded(true)}
          className={cn(
            "w-full h-full",
            objectFit,
            rounded,
            !hasLoaded && "bg-slate-300 animate-pulse",
            imageClassName
          )}
          {...props}
        />
      ) : (
        <div
          className={cn(
            "w-full h-full flex items-center justify-center text-gray-500 bg-gray-100",
            rounded,
            imageClassName
          )}
        >
          {fallback}
        </div>
      )}
    </div>
  );
};

export default RenderImage;

// const RenderImage = ({
//   src,
//   alt = "Image",
//   className = "",
//   imageClassName = "",
//   fallbackSrc = null,
//   placeholderImage = "",
//   fallback = null,
//   objectFit = "object-cover",
//   rounded = "rounded-md",
//   loading = false,
//   onClick = null,
//   effect = "blur",
//   style = {},    
//   ...props
// }) => {
//   // Current image source state
//   const [imgSrc, setImgSrc] = useState(src || fallbackSrc || placeholderImage);
//   const [hasError, setHasError] = useState(!src && !fallbackSrc);
//   const [hasLoaded, setHasLoaded] = useState(false);

//   // Handle image load error
//   const handleError = () => {
//     if (imgSrc === src && fallbackSrc) {
//       setImgSrc(fallbackSrc); 
//     } else if (imgSrc !== placeholderImage) {
//       setImgSrc(placeholderImage); 
//       setHasError(true);
//     }
//   };

//   // Show pulse skeleton if loading
//   if (loading) {
//     return (
//       <div
//         className={cn(
//           "w-full h-full bg-slate-300 animate-pulse",
//           rounded,
//           className
//         )}
//       />
//     );
//   }

//   return (
//     <div
//       className={cn(
//         "w-full h-full flex items-center justify-center overflow-hidden",
//         rounded,
//         className
//       )}
//       onClick={onClick}
//     >
//       {imgSrc && !hasError ? (
//         <LazyLoadImage
//           src={imgSrc}
//           alt={alt}
//           className={cn(
//             "w-full h-full",
//             objectFit,
//             rounded,
//             !hasLoaded && "bg-slate-300 animate-pulse",
//             imageClassName
//           )}
//           effect={effect}
//           onError={handleError}
//           onLoad={() => setHasLoaded(true)}
//           {...props}
//         />
//       ) : (
//         <div
//           className={cn(
//             "w-full h-full flex items-center justify-center text-gray-500 bg-gray-100",
//             rounded,
//             imageClassName
//           )}
//         >
//           {fallback || "Image unavailable"}
//         </div>
//       )}
//     </div>
//   );
// };

// export default RenderImage;